import { render, staticRenderFns } from "./header-subtotal.vue?vue&type=template&id=1b7147e2&scoped=true&"
import script from "./header-subtotal.vue?vue&type=script&lang=js&"
export * from "./header-subtotal.vue?vue&type=script&lang=js&"
import style0 from "./header-subtotal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./header-subtotal.vue?vue&type=style&index=1&id=1b7147e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7147e2",
  null
  
)

export default component.exports